import { Core } from "@faire/design-tokens";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { Row } from "@faire/web--source/slate/Layout";
import React from "react";
import styled, { css } from "styled-components";

import { ACCORDION_TRANSITION_TIMING } from "./utils";

export const ChevronIcon: React.FC<{ isAccordionOpen: boolean }> = ({
  isAccordionOpen,
}) => {
  return (
    <ChevronRow align="flex-start">
      <AnimatedChevron $isAccordionOpen={isAccordionOpen}>
        <Chevron
          data-test-id="accordion-chevron"
          direction="right"
          fontSize="16px"
          color={Core.icon.default}
        />
      </AnimatedChevron>
    </ChevronRow>
  );
};

const AnimatedChevron = styled.div<{ $isAccordionOpen: boolean }>`
  transform: rotate(
    ${({ $isAccordionOpen }) => css`
      ${$isAccordionOpen ? -90 : 90}deg
    `}
  );
  transition-property: transform;
  ${ACCORDION_TRANSITION_TIMING}
`;

const ChevronRow = styled(Row)`
  margin-left: auto;
  margin-right: 0;
`;
